import React from 'react';
import * as R from 'ramda';
// components
import { EmptyList } from '../../../../../components/list';
// helpers/constants
import * as G from '../../../../../helpers';
// icons
import * as I from '../../../../../svgs';
// ui
import { Box, Flex } from '../../../../../ui';
// feature configurations
import { ConfigGroupLeftSectionWrapper } from '../../../ui';
//////////////////////////////////////////////////

const iconColor = G.getTheme('icons.iconColor');

export const GeofencingColorsConfig = (props) => {
  const { configName, handleEditEntity, geofencingZoneColorConfig, deleteGeofencingZoneColorConfigRequest } = props;

  return (
    <Box>
      {
        G.isNilOrEmpty(geofencingZoneColorConfig) &&
        <EmptyList width='100%'>
          {G.getWindowLocale('titles:empty-list', 'Empty List')}
        </EmptyList>
      }
      {
        G.isNotNilAndNotEmpty(geofencingZoneColorConfig) &&
        <Flex alignItems='stretch'>
          <ConfigGroupLeftSectionWrapper>
            {G.getWindowLocale('titles:available-colors', 'Available Colors')}
          </ConfigGroupLeftSectionWrapper>
          <Flex
            flexGrow='1'
            p='0px 15px'
            borderBottom='1px solid'
            justifyContent='space-between'
            borderColor={G.getTheme('colors.bgGrey')}
          >
            <Flex>
              <Flex py={15} gap='8px' flexWrap='wrap' fontSize={12} alignItems='stretch'>
                {
                  R.pathOr([], ['colors'], geofencingZoneColorConfig).map((color, i) => (
                    <Box key={i} width={25} height={25} title={color} borderRadius='4px' background={color} />
                  ))
                }
              </Flex>
            </Flex>
            <Flex>
              <Box ml='8px' cursor='pointer' onClick={() => handleEditEntity(null, null, configName)}>
                {I.renderEditIcon(iconColor)}
              </Box>
              <Box
                ml='8px'
                cursor='pointer'
                onClick={() => deleteGeofencingZoneColorConfigRequest(G.getGuidFromObject(geofencingZoneColorConfig))}
              >
                {I.clean(iconColor)}
              </Box>
            </Flex>
          </Flex>
        </Flex>
      }
    </Box>
  );
};
